import { render, staticRenderFns } from "./VDate.vue?vue&type=template&id=4e201e82&scoped=true"
import script from "./VDate.vue?vue&type=script&lang=js"
export * from "./VDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e201e82",
  null
  
)

export default component.exports